import React from "react";

interface IdentifierProps {
  value: number | string | undefined;
  title?: string;
}

export function Identifier(props: IdentifierProps) {
  if (props.value == undefined) return null;
  return (
    <span className="text-muted small" title={props.title}>
      #{props.value}
    </span>
  );
}
